import type { StpInstance } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { initialTechnologies } from 'components/Graph/GraphState';
import { ungroupStpGroup } from 'components/Graph/commands/ungroupStpGroup';
import { updateStpInstanceIsolate } from 'components/Graph/commands/updateStpInstanceIsolate';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export type UpdateStpInstanceCommand = {
  instance: StpInstance;
};

export const updateStpInstance: GraphCommandFactory<UpdateStpInstanceCommand> =
  (cmdContext, dispatch) => (command) => {
    cmdContext.updateState((draft) => {
      const {
        technologies: {
          selectedTechnologies: {
            stpInstances = initialTechnologies.stpInstances,
          },
        },
      } = draft;

      stpInstances.instances = stpInstances.instances.filter(
        ({ rootId, vlanId }) =>
          !(
            rootId === command.instance.rootId &&
            vlanId === command.instance.vlanId
          ),
      );

      stpInstances.instances.push(command.instance);
    });

    const { instances = [] } =
      cmdContext.getState().technologies.selectedTechnologies.stpInstances ??
      initialTechnologies.stpInstances;

    if (instances.filter(prop('visible')).length === 0) {
      dispatch(updateStpInstanceIsolate, { isolate: false });
    }

    dispatch(ungroupStpGroup);
  };
